import React from 'react';

const DeleteAccessoriesPopup = ({ cleanAccessories }) => {
  const closePopup = e => {
    const popup = e.target.closest(`[data-popup-name="delete-accessories-popup"]`);
    popup.classList.remove('open');
    cleanAccessories();
  };

  return (
    <>
      <p>Czy na pewno chcesz usunąć z szafy wszystkie akcesoria?</p>
      <button className="button" onClick={closePopup}>
        OK
      </button>
    </>
  );
};

export default DeleteAccessoriesPopup;
